import { db } from '../../../../firebaseConfig';
import { collection, query, where, getDocs, getDoc, doc, updateDoc, Timestamp } from 'firebase/firestore';

// Funtion to assign user to a lead from departments which should be round robin style
const assignByDepartment = async (userId: string, companyId: string, departmentId: string, leadId: string): Promise<{ message: string }> => {

    // Check if the user is logged in
    const currentUser = await getDoc(doc(db, 'users', userId));
    if (!currentUser.exists()) {
        throw new Error('User not found or not logged in');
    }
    const userData = currentUser.data();
    if (!userData || !userData.companyId || userData.companyId !== companyId) {
        throw new Error('User does not belong to this company');
    }

    // Find the number of users with this department
    const usersQuery = query(
        collection(db, 'users'),
        where('companyId', '==', companyId),
        where('departmentId', '==', departmentId),
        where('isActive', '==', true)
    );
    const usersSnapshot = await getDocs(usersQuery);
    const userCount = usersSnapshot.size;
    console.log(`Number of active users in department ${departmentId}: ${userCount}`);

    if (userCount === 0) {
        throw new Error('No users found in this department');
    }

    // Get the users in this department
    const users = usersSnapshot.docs.map(doc => doc.id);
    console.log(users, `Number of users in department ${departmentId}: ${userCount}`);

    // Get the department document reference
    const departmentDocRef = doc(db, 'companies', companyId, 'departments', departmentId);
    const departmentSnapshot = await getDoc(departmentDocRef);
    if (!departmentSnapshot.exists()) {
        throw new Error('Department not found');
    }
    const departmentData = departmentSnapshot.data();
    if (!departmentData) {
        throw new Error('Department data not found');
    }

    // Ensure totalLeadsAssigned is a valid number
    const currentTotalLeadsAssigned = typeof departmentData.totalLeadsAssigned === 'number' && !isNaN(departmentData.totalLeadsAssigned)
        ? departmentData.totalLeadsAssigned
        : 0;

    console.log(`Current total leads assigned: ${currentTotalLeadsAssigned}`);

    // Calculate the next user index in round robin style
    const nextUserIndex = currentTotalLeadsAssigned % users.length;
    console.log(`Next user index: ${nextUserIndex}`);

    // Get the user to assign the lead to
    const userToAssign = users[nextUserIndex];
    console.log(`User to assign: ${userToAssign}`);

    if (!userToAssign) {
        throw new Error('User to assign lead not found');
    }

    // Update the lead with the user uid
    const leadDocRef = doc(db, 'companies', companyId, 'leads', leadId);
    await updateDoc(leadDocRef, {
        assignedTo: userToAssign,
        updatedAt: Timestamp.now(),
        updatedBy: userId,
    });

    // Check if lead has activeFollowUpId
    const leadSnapshot = await getDoc(leadDocRef);
    if (!leadSnapshot.exists()) {
        throw new Error('Lead not found');
    }
    const leadData = leadSnapshot.data();
    const activeFollowUpId = leadData.activeFollowUpId || null;
    if (activeFollowUpId) {
        // Update the follow-up with the user uid
        const followUpDocRef = doc(db, `companies/${companyId}/followUps`, activeFollowUpId);
        await updateDoc(followUpDocRef, {
            userId: userToAssign,
        });
        console.log(`Follow-up ${activeFollowUpId} assigned to user ${userToAssign}`);
    }

    // Update the department's totalLeadsAssigned (increment by 1 from current value)
    const newTotalLeadsAssigned = currentTotalLeadsAssigned + 1;
    await updateDoc(departmentDocRef, {
        totalLeadsAssigned: newTotalLeadsAssigned
    });

    console.log(`Lead ${leadId} assigned to user ${userToAssign} in department ${departmentId}`);
    console.log(`Updated total leads assigned: ${newTotalLeadsAssigned}`);

    return { message: `Lead ${leadId} assigned to user ${userToAssign} in department ${departmentId}` };
}


export default assignByDepartment;